/**
 * @generated SignedSource<<6f409232dfe70b49086ed75c82bb4b01>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4Profile$data = {
  readonly me: {
    readonly user: {
      readonly email?: string | null | undefined;
      readonly picture: AGG$URL;
    } | null | undefined;
  };
  readonly " $fragmentType": "Nav4Profile";
};
export type Nav4Profile$key = {
  readonly " $data"?: Nav4Profile$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4Profile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "Nav4Profile",
  "selections": [
    {
      "concreteType": "AuthenticationContext",
      "kind": "LinkedField",
      "name": "me",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "picture"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "email"
                }
              ],
              "type": "AtlassianAccountUser"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "b587d618b47ab2faaf585a782a74ec40";

export default node;
